<!-- ✅ SmartSwap Alert Card Premium Edition -->
<div (click)="toggleCollapse()" class="cursor-pointer select-none">
  <ng-container *ngIf="isCollapsed; else expandedView">
    <!-- 🔹 VERSION PLIÉE -->
    <div class="relative flex items-center gap-3 px-4 py-3 rounded-2xl shadow-md transition hover:shadow-lg hover:scale-[1.01] duration-200 ease-in-out"
         [ngClass]="alert.triggered
       ? 'bg-gradient-to-r from-orange-400 via-orange-500 to-red-500'
       : 'bg-gradient-to-r from-purple-500 via-purple-600 to-indigo-600'">

      <!-- Icône stylisée en plein centre -->
      <div *ngIf="alert.triggered"
           class="absolute inset-0 flex items-center justify-center pointer-events-none">
        <svg class="w-8 h-8 text-white opacity-80  drop-shadow-lg" fill="none" stroke="currentColor" stroke-width="2"
             viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round"
                d="M12 9v2m0 4h.01M5.93 20h12.14a2 2 0 001.73-3l-6.07-10.5a2 2 0 00-3.46 0L4.2 17a2 2 0 001.73 3z" />
        </svg>
      </div>


      <div class="w-6 h-6 flex items-center justify-center rounded-full bg-white/10 backdrop-blur-sm shadow-sm">
        <svg class="w-4 h-4 text-white" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" d="M13 10V3L4 14h7v7l9-11h-7z" />
        </svg>
      </div>
      <div class="flex flex-col leading-tight">
        <span class="text-sm font-bold text-white">Smart Swap</span>
        <span *ngIf="alert.createdAt" class="text-[10px] text-white/70 mt-0.5">
          {{ alert.createdAt | date:'shortDate' }}
        </span>
      </div>

      <span class="ml-auto text-white text-xs font-bold px-2.5 py-1 rounded-full bg-white/20 backdrop-blur-md shadow-sm whitespace-nowrap">
        {{ alert.amountIn }} {{ alert.tokenIn }} → {{ alert.tokenOut }}
      </span>
    </div>
  </ng-container>

  <!-- 🔸 VERSION DÉPLIÉE -->
  <ng-template #expandedView>
    <div class="rounded-2xl shadow-xl space-y-4 transition-all duration-300"
         [ngClass]="{
         'bg-white text-black': !isDarkMode(),
         'bg-[#1e1e2f]/70 text-white': isDarkMode()
       }">

      <!-- FULL-WIDTH HEADER COLLÉ EN HAUT (intégré dans la même div) -->
      <div class="relative flex items-center gap-3 px-4 py-3 rounded-2xl shadow-md transition hover:shadow-lg hover:scale-[1.01] duration-200 ease-in-out"
           [ngClass]="alert.triggered
       ? 'bg-gradient-to-r from-orange-400 via-orange-500 to-red-500'
       : 'bg-gradient-to-r from-purple-500 via-purple-600 to-indigo-600'">
        <div class="w-6 h-6 flex items-center justify-center rounded-full bg-white/10 backdrop-blur-sm shadow-sm">




          <svg class="w-4 h-4 text-white" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" d="M13 10V3L4 14h7v7l9-11h-7z" />
          </svg>
        </div>
        <div class="flex flex-col leading-tight">
          <span class="text-sm font-bold text-white">Smart Swap</span>
          <span *ngIf="alert.createdAt" class="text-[10px] text-white/70 mt-0.5">
            {{ alert.createdAt | date:'shortDate' }}
          </span>
        </div>
        <div *ngIf="alert.triggered"
             class="absolute inset-0 flex items-center justify-center pointer-events-none">
          <svg class="w-8 h-8 text-white opacity-80  drop-shadow-lg" fill="none" stroke="currentColor" stroke-width="2"
               viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round"
                  d="M12 9v2m0 4h.01M5.93 20h12.14a2 2 0 001.73-3l-6.07-10.5a2 2 0 00-3.46 0L4.2 17a2 2 0 001.73 3z" />
          </svg>
        </div>
        <span class="ml-auto text-white text-xs font-bold px-2.5 py-1 rounded-full bg-white/20 backdrop-blur-md shadow-sm whitespace-nowrap">
          {{ alert.amountIn }} {{ alert.tokenIn }} → {{ alert.tokenOut }}
        </span>
      </div>

      <!-- CONTENU DE LA CARTE (dans la même div globale) -->
      <div class="px-5 pb-5 space-y-4 text-sm">
        <span *ngIf="!alert.active" class="text-yellow-400 text-xs animate-pulse font-medium">
          ({{ 'INACTIVE' | translate }})
        </span>

        <div class="grid grid-cols-2 gap-2">
          <!-- Colonne gauche -->
          <div class="flex justify-between">
            <span class="font">{{ 'SELL_TOKEN' | translate }}</span>
          </div>

          <!-- Colonne droite -->
          <div *ngIf="alert.threshold" class="flex flex-col items-end">
            <div class="flex justify">
              <span class="font-medium">{{ alert.amountIn }} {{ getTokenLabel(alert.tokenIn) }}</span>
            </div>

          </div>
        </div>
        <div class="grid grid-cols-2 gap-2">
          <!-- Colonne gauche -->
          <div class="flex justify-between w-full">
            <span class="font">{{ 'AT_LEAST' | translate }}</span>
            
          </div>


          <!-- Colonne droite -->
          <div *ngIf="alert.threshold" class="flex flex-col items-end">
            <span class="font-medium">{{ alert.threshold | number:'1.2-2' }} {{ getTokenLabel(alert.tokenOut) }}</span>
            <div *ngIf="getExpectedGainPercentage()" class="text-xs text-gray-400 mt-0.5">
              ({{ getExpectedGainPercentage() }} {{ 'EXPECTED_GAIN' | translate }})
            </div>
          </div>
        </div>

        <!-- GAUGES -->
        <div *ngIf="alert.initialAmountOut && alert.threshold && alert.liveQuote" class="mx-auto w-fit">
          <svg viewBox="0 0 200 100" class="w-32 h-16">
            <ng-container *ngFor="let i of segmentArray">
              <line [attr.x1]="getSegmentX(i, true)" [attr.y1]="getSegmentY(i, true)" [attr.x2]="getSegmentX(i, false)" [attr.y2]="getSegmentY(i, false)" [attr.stroke]="i < coloredSegmentCount ? getSegmentColor(i) : '#1f2937'" stroke-width="3" stroke-linecap="round" />
            </ng-container>
            <text x="100" y="95" text-anchor="middle" class="font font-semibold text-[18px] select-none">{{ getFormattedGainProgress() }}</text>
          </svg>
        </div>

        <div *ngIf="alert.liveQuote" class="bg-white/5 text-green-400 rounded-xl px-3 py-2 text-xs">
          ✅ {{ 'YOU_NOW_RECEIVE' | translate }} :
          <strong class="text-sm">{{ alert.liveQuote | number:'1.2-2' }} {{ alert.tokenOut }}</strong>
          {{ 'FOR' | translate }} {{ alert.amountIn }} {{ alert.tokenIn }}
          <img *ngIf="alert.chainId" [src]="CHAIN_MAP[alert.chainId]?.icon" [alt]="CHAIN_MAP[alert.chainId]?.name" class="inline-block w-4 h-4 align-text-bottom ml-1" />
        </div>


        <div class="grid grid-cols-2 gap-2">
          <!-- Colonne gauche -->
          <div class="flex justify-between">
            <span class="font">{{ 'FEES_UNDER' | translate }}</span>
          </div>

          <!-- Colonne droite -->
          <div *ngIf="alert.threshold" class="flex flex-col items-end">
            <div class="flex justify">
              <span class="font-medium">{{ displayedGasFiat | number: '1.0-2' }} GWEI</span>
            </div>

            <div *ngIf="getExpectedGainPercentageGas()" class="text-xs text-gray-400 mt-0.5">
              ({{ getExpectedGainPercentageGas() }} {{ 'EXPECTED_GAIN' | translate }})
            </div>
          </div>
        </div>
        <div *ngIf="alert.maxGasFee && alert.currentGasFee" class="mx-auto w-fit">
          <svg viewBox="0 0 200 100" class="w-32 h-16">
            <ng-container *ngFor="let i of gasSegmentArray">
              <line [attr.x1]="getGasSegmentX(i, true)" [attr.y1]="getGasSegmentY(i, true)" [attr.x2]="getGasSegmentX(i, false)" [attr.y2]="getGasSegmentY(i, false)" [attr.stroke]="i < gasColoredSegmentCount ? getGasSegmentColor(i) : '#1f2937'" stroke-width="3" stroke-linecap="round" />
            </ng-container>
            <text x="100" y="95" text-anchor="middle" class="font font-semibold text-[18px] select-none">{{ getFormattedGainProgressGas() }}</text>
          </svg>
        </div>

        <div *ngIf="alert.currentGasFee" class="text-green-400 bg-white/5 rounded-xl px-3 py-2 text-xs">
          ✅ {{ 'CURRENT_FEES' | translate }} :
          <strong class="text-sm">{{ displayedCurrentGasFiat | number: '1.0-2' }} GWEI</strong>
        </div>

        <div *ngIf="alert.threshold && alert.maxGasFee" [ngClass]="{
        'bg-purple-100 text-purple-900 dark:bg-purple-900/30 dark:text-purple-200': alert.conditionMode === 'AND',
        'bg-indigo-100 text-indigo-900 dark:bg-indigo-900/30 dark:text-indigo-200': alert.conditionMode === 'OR'
      }" class="rounded-xl px-3 py-2 text-xs font-semibold text-center shadow-sm tracking-wide">
          {{ alert.conditionMode === 'AND' ? ('AND_SWAP_CONDITION' | translate) : ('OR_SWAP_CONDITION' | translate) }}
        </div>

        <div class="flex justify-between items-center gap-2 mt-4">
          <button *ngIf="alert.triggered" class="px-4 py-1.5 text-yellow-500 border border-yellow-400 hover:border-yellow-500 hover:text-yellow-400 font-medium rounded-full text-sm transition-all duration-200">🔁 {{ 'REACTIVATE' | translate }}</button>

          <button class="px-5 py-1.5 text-white bg-gradient-to-r from-purple-500 to-indigo-600 hover:brightness-110 font-semibold rounded-full shadow text-sm transition-all duration-200" (click)="goToSwap.emit(alert)">Swap</button>

          <button (click)="removeAlert.emit(alert)" [disabled]="isLoading" class="px-4 py-1.5 flex items-center justify-center gap-1 text-red-500 hover:text-white border border-red-500 hover:bg-red-500 rounded-full text-sm transition-all duration-200 shadow-sm disabled:opacity-50 disabled:cursor-not-allowed">
            <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
            </svg>
            {{ 'DELETE' | translate }}
          </button>
        </div>
      </div>
    </div>
  </ng-template>

</div>
